import useBRData from "./usebrdata";
import { useState } from "react";

// see useTeam for more details
// This hook should only reutrn an array of players
const useSquad = (teamId, accessKey) => {
  const { data } = useBRData("p", { teamid: teamId }, accessKey);
  let players = [];

  if (data && data.players) {
    for (const [key, value] of Object.entries(data.players)) {
      players.push(value)
    }
  }
  
  return { data: players };
};

export default useSquad;
